import React from 'react';
import { useMessages } from './MessageContext';
import MessageItem from './MessageItem';
import './Messages.css';

const MessageContainer = () => {
  const { messages } = useMessages();

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="message-container">
      {messages.map(message => (
        <MessageItem
          key={message.id}
          message={message}
        />
      ))}
    </div>
  );
};

export default MessageContainer;